/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

/** One selectable ordering: the wire params plus its menu label. */
export type SortChoice = {
  value: string;
  label: string;
  sortBy: string;
  sortOrder: "asc" | "desc";
};

export const NEWEST: SortChoice = {
  value: "createdAt:desc",
  label: "Newest first",
  sortBy: "createdAt",
  sortOrder: "desc",
};

export const OLDEST: SortChoice = {
  value: "createdAt:asc",
  label: "Oldest first",
  sortBy: "createdAt",
  sortOrder: "asc",
};

export function sortChoice(choices: SortChoice[], value: string): SortChoice {
  return choices.find((choice) => choice.value === value) ?? choices[0] ?? NEWEST;
}

/** An ordering the menu does not list, which a table header offers: its value names the pair. */
export function headerSort(
  sortBy: string,
  sortOrder: SortChoice["sortOrder"],
  label: string,
): SortChoice {
  return { value: `${sortBy}:${sortOrder}`, label, sortBy, sortOrder };
}

/** The url with the sort menu's value, the only list state the url keeps besides filters. */
export function paramsWithSort(params: URLSearchParams, value: string): URLSearchParams {
  const next = new URLSearchParams(params);
  next.set("sort", value);
  return next;
}

export function withSort(params: URLSearchParams, choice: SortChoice): URLSearchParams {
  params.set("sortBy", choice.sortBy);
  params.set("sortOrder", choice.sortOrder);
  return params;
}

export const ACCOUNT_SORTS: SortChoice[] = [NEWEST, OLDEST];

export const DUPLICATE_SORTS: SortChoice[] = [
  NEWEST,
  OLDEST,
  { value: "score:desc", label: "Highest score", sortBy: "score", sortOrder: "desc" },
];

export const HIGHEST_SCORE: SortChoice = {
  value: "score:desc",
  label: "Highest score",
  sortBy: "score",
  sortOrder: "desc",
};

export const RECENTLY_SEEN: SortChoice = {
  value: "lastSeenAt:desc",
  label: "Recently seen",
  sortBy: "lastSeenAt",
  sortOrder: "desc",
};

export const REGISTRY_DUPLICATE_SORTS: SortChoice[] = [HIGHEST_SCORE, NEWEST, OLDEST, RECENTLY_SEEN];

export const STAFF_FAMILY_SORTS: SortChoice[] = [
  { value: "assignedAt:desc", label: "Recently assigned", sortBy: "assignedAt", sortOrder: "desc" },
  { value: "familyId:asc", label: "Family id", sortBy: "familyId", sortOrder: "asc" },
];
